var map = {
	"./advert.svg": "ea4d",
	"./arrow.svg": "21e2",
	"./bag.svg": "47fd",
	"./bank.svg": "02f2",
	"./basket.svg": "382e",
	"./calendar.svg": "b8bd",
	"./close.svg": "8b1b",
	"./coins.svg": "40ac",
	"./downloadFile.svg": "8a94",
	"./exchange.svg": "3edd",
	"./handCoin.svg": "840f",
	"./lineCart.svg": "1c71",
	"./lock.svg": "9619",
	"./office.svg": "3dec",
	"./pencil.svg": "e51f",
	"./plus.svg": "eb38",
	"./priceTag.svg": "8e9b",
	"./rest.svg": "6e6c",
	"./safe.svg": "ce81",
	"./server.svg": "90f6",
	"./shoppingBag.svg": "ed58",
	"./stack.svg": "52e8",
	"./store.svg": "e29b",
	"./suitcase.svg": "20c5",
	"./terminal.svg": "e7bd",
	"./time.svg": "79aa",
	"./user.svg": "6aed",
	"./wallet.svg": "4f4a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6f32";